import type { OpenPaymentOptions, OPGSDK, SDKConfiguration } from './types';
import { isOpen, setCallbacks } from './state';
import { createModal, closeModal } from './modal';
import { configure as configureSDK, isSandboxMode, getConfig } from './config';

export type {
  TransactionStatus,
  PaymentResultStatus,
  PaymentResult,
  PaymentCallbacks,
  OpenPaymentOptions,
  OPGSDK,
  SDKConfiguration,
} from './types';

const publicKey = document.currentScript?.getAttribute("data-client-key") ?? undefined;
const sandboxAttr = document.currentScript?.getAttribute("data-sandbox");
const isSandboxFromAttr = sandboxAttr !== 'false';

configureSDK({ sandbox: isSandboxFromAttr });

function openPayment(options: OpenPaymentOptions): void {
  if (isOpen()) {
    console.warn('[opg-sdk] Payment modal is already open');
    return;
  }

  if (!options.clientSecret) {
    throw new Error('[opg-sdk] Payment clientSecret is required');
  }

  if (!options.paymentId) {
    throw new Error('[opg-sdk] Payment paymentId is required');
  }

  if (!publicKey) {
    throw new Error('[opg-sdk] Payment publicKey is required');
  }

  if (options.sandbox !== undefined) {
    configureSDK({ sandbox: options.sandbox });
  }

  const { clientSecret, paymentId, token, onSuccess, onPending, onError } = options;

  setCallbacks({
    onSuccess,
    onPending,
    onError,
  });

  createModal(clientSecret, paymentId, publicKey, token);
}

function closePayment(): void {
  closeModal();
}

function isPaymentOpen(): boolean {
  return isOpen();
}

function configure(config: Partial<SDKConfiguration>): void {
  configureSDK(config);
}

function isSandbox(): boolean {
  return isSandboxMode();
}

const OPG: OPGSDK = {
  openPayment,
  closePayment,
  isPaymentOpen,
  configure,
  isSandbox,
};

export { openPayment, closePayment, isPaymentOpen, configure, isSandbox };
export default OPG;
